import { render, staticRenderFns } from "./ChartBarPieHistogram.vue?vue&type=template&id=5d7e8b44&scoped=true&"
import script from "./ChartBarPieHistogram.vue?vue&type=script&lang=js&"
export * from "./ChartBarPieHistogram.vue?vue&type=script&lang=js&"
import style0 from "./ChartBarPieHistogram.vue?vue&type=style&index=0&id=5d7e8b44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7e8b44",
  null
  
)

export default component.exports